import { useFeatureFlags } from 'config/featureFlags/hooks';

import { FeatureFlags } from './configFromAdmin';

export const useConfig = (configKey: FeatureFlags) => {
  const featureFlags = useFeatureFlags();
  return featureFlags[configKey] || false;
};
